import Icon from '../components/Icon';

const Weather1Colored = Icon(
  'weather-1-colored',
  <>
    <path
      fill="#4C8BF9"
      fillRule="evenodd"
      d="M8.887 3.954c2.435-1.756 5.666-2.52 8.808-1.487a.488.488 0 0 1 .048.91c-.873.395-1.73 1.018-2.5 1.798 2.797 1.393 4.984 3.794 4.984 7.299 0 3.043-1.683 5.819-4.114 7.572-2.435 1.756-5.666 2.52-8.808 1.487a.488.488 0 0 1-.048-.91c1.015-.459 1.977-1.003 2.806-1.65-2.943-1.37-5.29-3.814-5.29-7.447 0-3.043 1.683-5.819 4.114-7.572m.989 8.062a2.645 2.645 0 0 1 2.64-2.65 2.645 2.645 0 0 1 2.64 2.65 2.645 2.645 0 0 1-2.64 2.65 2.645 2.645 0 0 1-2.64-2.65"
      clipRule="evenodd"
    />
  </>
);

export default Weather1Colored;
